import { Component, ViewChild, PLATFORM_ID, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { UserService } from '../../../../services/user.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, TranslateModule, BaseChartDirective, FormsModule, RouterLink],
  providers: [provideCharts(withDefaultRegisterables()), Base64UrlService],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  encodeURIComponent = encodeURIComponent;
  lang: any;
  userConsent!: string;
  timeSheetID: any;
  associatesData: any;
  allAssociatesData: any; // すべての稼働データ
  selectedAssociateIndex: number = 0; // 選択中の稼働インデックス
  monthDropdown: any;
  selectedMonth: string = '';
  monthFormat: string = '';
  disYear: string = '';
  emailToken: any;
  emailSuccess: boolean = false;
  access: boolean = true;
  noticeContent: any;
  noticeHeading: any;
  noAvailableMonthData: boolean = false;
  passwordExpiryDate: string = '';
  userEmail: string = '';
  
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  constructor(private auth: AuthService,private router: Router, private translate: TranslateService, private pageTitle: PageTitleService, private user: UserService, private en: EncryptionService, private ts: TimesheetService
    ,private safeUrl: Base64UrlService, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object) { 
    
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 

      this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }    
  }

  public barChartType: ChartType = 'bar';
  public paiChartType: ChartType = 'doughnut';

  public barChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [      
      {
        data: [],        
        backgroundColor: [],
        maxBarThickness: 30,
        borderColor: '#fff',
        borderWidth: 2        
      }
    ]
  };
  
  public pieChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderColor: '#fff',
        borderWidth: 2
      }
    ],
    
  };
  
  public pieChartDataAR: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],        
        borderColor: 'rgba(255, 255, 255, 1)',
        borderWidth: 2,        
      }
    ], 
  };

  public barChartDatasets: any[] = [];

  public pieChartLabels: any[] = [];
  public pieChartDatasets: any[] = [];  
  
  public pieChartLabelsAR: any[] = [];
  public pieChartDatasetsAR: any[] = [];
  
  public pieChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: { display: false }
    }
  };
  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false }, 
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          font: { size: 11 }
        }
      },
      y: {
        ticks: {
          stepSize: 1,
          callback: (value: any) => Number.isInteger(value) ? value : null
        }
      }
    }
  };
 
  
  ngOnInit() {
    // console.log(this.auth.getRole());
    // if (this.auth.getRole() !== 'Staff') {
    //   // this.router.navigate(['client-associatelist']);
    //   this.access = false;
    //   return
    // }
    this.emailToken = null;
    // this.route.queryParams.subscribe(params => {
    //   if (params['token']) {
    //     const rawToken = params['token'];
    //     this.emailToken = decodeURIComponent(rawToken || '');
    //     localStorage.setItem('emailtoken', this.emailToken);
    //     console.log('Decoded token:', this.emailToken);
    //     return;
    //   }
    // });

    if (localStorage.getItem('emailtoken')) {
      this.emailToken = localStorage.getItem('emailtoken');
      // console.log("store")
    }
    // console.log(this.emailToken);
    if (isPlatformBrowser(this.platformId)) {
      // this.userConsent = history.state['consent'];
      this.userConsent = this.auth.getNotice()?? 'no';
      // console.log('Consent:', this.userConsent);
      this.passwordExpiryDate = this.auth.getPasswordExpiryDate() || '';
      this.userEmail = this.auth.getEmail() ?? '';
    
      setTimeout(() => {
        this.pageTitle.setTitle('menu.home'); // translation key
      });
      this.getMonthDrpDwn();
      this.getNotification();
      if (this.emailToken) {            
            this.acceptEmailChange();
          }          
          //this.getSummary(newFormat);

      this.translate.onLangChange.subscribe(() => {
        this.lang = localStorage.getItem('site_lang') || 'en';
        this.refreshChartLabels();
      });
    }
  }

  refreshChartLabels() {
    if (!this.allAssociatesData) return;
    this.allAssociatesData = this.allAssociatesData.map((item: any) => {
      const data = item.barChartData?.datasets[0]?.data || [0, 0, 0, 0];
      return {
        ...item,
        barChartData: {
          ...item.barChartData,
          labels: [
            [this.translate.instant('Home.CHART_ATTENDANCE'), String(data[0])],
            [this.translate.instant('Home.WORK_FROM_HOME'), String(data[1])],
            [this.translate.instant('Home.PAID_HOLIDAY'), String(data[2])],
            [this.translate.instant('Home.ABSENCE'), String(data[3])]
          ]
        }
      };
    });
    this.associatesData = [this.allAssociatesData[this.selectedAssociateIndex]];
  }
  
  getNotification() {
    this.auth.getEmailContent() 
      .subscribe({
        next: (res: any) => {
          this.noticeContent = res.data.content;
          this.noticeHeading = res.data.title;
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			      return	
          }
        }
    })
  }
  getMonthDrpDwn() {
    // 戻り先月を同期的に取得（subscribe外で確実に読む）
    const pendingReturnMonth = this.ts.returnToMonth;
    this.ts.returnToMonth = null;
    
    // this.ts.getMonthList()
    this.ts.getMonthListV2()
      .subscribe({
        next: (resMonthList: any) => {
          // 空エントリ（当月データなし時に挿入される先頭の空行）を除外してドロップダウンを設定
          this.monthDropdown = resMonthList.data.filter((d: any) => d.dayDate);

          if (!resMonthList.data[0]?.dayDate) {
            // 当月にタイムシートが存在しない場合
            // ただし戻り先月が指定されていてドロップダウンにデータがあれば、その月で続行
            const validSaved = pendingReturnMonth && this.monthDropdown.some((d: any) => {
              const [dd, mm, yy] = d.dayDate.split('-');
              return `${yy}-${mm}-${dd}` === pendingReturnMonth;
            });
            if (!validSaved) {
              this.noAvailableMonthData = true;
              return;
            }
          }

          const defaultEntry = this.monthDropdown.find((d: any) => d.isDefault) ?? this.monthDropdown[0];
          const [day0, month0, year0] = defaultEntry.dayDate.split('-');
          let defaultFormat = `${year0}-${month0}-${day0}`;

          const validSaved = pendingReturnMonth && this.monthDropdown.some((d: any) => {
            const [dd, mm, yy] = d.dayDate.split('-');
            return `${yy}-${mm}-${dd}` === pendingReturnMonth;
          });

          let newFormat = validSaved ? pendingReturnMonth! : defaultFormat;

          if (this.emailToken) {            
            this.acceptEmailChange();
          }          
          this.getSummary(newFormat);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
            return;
          }
        }
      });
  }

  getSummary(srchDate: string) {
    sessionStorage.setItem('home_selected_month', srchDate);
    const [year, month, day] = srchDate.split('-');
    let newFormat = `${day}-${month}-${year}`;
    this.monthFormat = this.getMonth(newFormat);
    this.disYear = this.getYear(newFormat);
    
    this.ts.getAssociates(srchDate)
      .subscribe({
        next: (res: any) => {
          this.selectedMonth = newFormat;
          const rawIds: number[] = (res.data ?? []).map((item: any) => item.timesheetID);
          this.associatesData = this.applyEncryption(res.data.map((item: any) => ({...item})));
         // this.associatesData = res.data;
          this.associatesData = this.associatesData.map((item: any) => {
            return {
              ...item,
              pieChartCombined: {
                labels: [
                  this.translate.instant('LONGSTATUS.NOTSUBMIT'),
                  this.translate.instant('LONGSTATUS.SUBMIT'),
                  this.translate.instant('REJECT'),
                  this.translate.instant('APPROVE')
                ],
                datasets: [
                  {
                    data: [item.notSubmit, item.submit, item.reject, item.approve],
                    backgroundColor: [
                      '#CCCC00',
                      'rgba(112, 191, 92, 1)',
                      'rgba(228, 65, 95, 1)',
                      'rgba(56, 147, 205, 1)'
                    ],
                    borderColor: '#fff',
                    borderWidth: 2
                  }
                ]
              },
              barChartData: {
                labels: [
                  [this.translate.instant('Home.CHART_ATTENDANCE'), '0'],
                  [this.translate.instant('Home.WORK_FROM_HOME'), String(item.teleWork)],
                  [this.translate.instant('Home.PAID_HOLIDAY'), String(Math.round(item.paidHoliday))],
                  [this.translate.instant('Home.ABSENCE'), String(Math.round(item.absence))]
                ],
                datasets: [
                  {
                    data: [0, item.teleWork, Math.round(item.paidHoliday), Math.round(item.absence)],
                    backgroundColor: ['rgba(34, 197, 94, 1)', 'rgba(56, 147, 205, 1)', 'rgba(153, 102, 255, 1)', 'rgba(228, 65, 95, 1)'],
                    label: ' ',
                  }
                ]
              },
              midnightInside: item.midnightInside ?? '00:00',
              midnightOutside: item.midnightOutside ?? '00:00'
            }
          });
          // console.log(this.associatesData[0].submit);
          // this.pieChartData.labels = ['Not Submitted: '+this.associatesData[0].notSubmit, 'Submitted: '+this.associatesData[0].submit];
          // this.pieChartData.datasets[0].data = [this.associatesData[0].notSubmit, this.associatesData[0].submit]; // dynamic values from API
          // this.pieChartDataAR.labels = ['Approve: '+this.associatesData[0].approve, 'Reject: '+this.associatesData[0].reject];
          // this.pieChartDataAR.datasets[0].data = [this.associatesData[0].approve, this.associatesData[0].reject]; // dynamic values from API
          // this.barChartData.datasets[0].data = [this.associatesData[0].wfh, this.associatesData[0].absence, this.associatesData[0].paidHoliday]; // dynamic values from API
          
          // すべてのデータを保存して、最初の1つだけを表示
          if (this.associatesData && this.associatesData.length > 0) {
            this.allAssociatesData = [...this.associatesData];
            this.selectedAssociateIndex = 0;
            this.associatesData = [this.allAssociatesData[0]];
            this.noAvailableMonthData = false;
            // 出勤日数を取得して棒グラフに反映（2回目以降はキャッシュから即時）
            forkJoin(rawIds.map((id: number) => this.ts.getTsInfoSummary(id))).subscribe({
              next: (summaries: any[]) => {
                this.allAssociatesData = this.allAssociatesData.map((item: any, idx: number) => {
                  const attDays = summaries[idx]?.attendanceDays ?? 0;
                  return {
                    ...item,
                    barChartData: {
                      labels: [
                        [this.translate.instant('Home.CHART_ATTENDANCE'), String(attDays)],
                        [this.translate.instant('Home.WORK_FROM_HOME'), String(item.teleWork)],
                        [this.translate.instant('Home.PAID_HOLIDAY'), String(Math.round(item.paidHoliday))],
                        [this.translate.instant('Home.ABSENCE'), String(Math.round(item.absence))]
                      ],
                      datasets: [{
                        data: [attDays, item.teleWork, Math.round(item.paidHoliday), Math.round(item.absence)],
                        backgroundColor: ['rgba(34, 197, 94, 1)', 'rgba(56, 147, 205, 1)', 'rgba(153, 102, 255, 1)', 'rgba(228, 65, 95, 1)'],
                        label: ' ',
                      }]
                    }
                  };
                });
                this.associatesData = [this.allAssociatesData[this.selectedAssociateIndex]];
                this.chart?.update();
              },
              error: () => {
                // getTsInfoSummary失敗時（404等）は出勤日数0のまま表示継続
              }
            });
          } else {
            this.noAvailableMonthData = true;
          }
          
          this.chart?.update();
        }, 
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
            return;
          }
        }
    })
  }

  fncCng(event: any) {
    let dateFormat = this.getDateFromEvent(event);
    this.getSummary(dateFormat);
  }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }
  
  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short'});
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric'});
  }
  
  giveConsent(isChecked: boolean) {
    if (isChecked) {
      // console.log('Checkbox is checked');
      let consentObj = {
        "termId": 2,
        "termValue": true
      }
      this.user.giveConsent(consentObj)
        .subscribe({
            next: (res: any) => {
            if (res.status) {
                this.auth.storeNotice('yes');
                this.userConsent = 'yes';

              } else {
                alert(res.message);
              }
          },
          error: (err: any) => {
            if(err.status === 401) {
              this.auth.logout();
			        return;	
            }
          }
      })
    } else {
      // alert('Checkbox is not checked');
      this.userConsent = 'yes';
    }
  }

  applyEncryption(dt:any){
    dt.forEach((elm:any,ind:any) => {
      dt[ind].timesheetID = Base64UrlService.encode(this.en.encryptionAES(elm.timesheetID.toString()));
      console.log(this.en.encryptionAES(elm.timesheetID.toString()));
      console.log(dt[ind].timesheetID);
    });
    // dt = this.en.encryptionAES(dt.toString())
    return dt;
  }

  cancelConsent() {
    this.auth.logout();
  }

  acceptEmailChange() {
    const payLoad = {
      "token": this.emailToken,
      "confirm": true
    }

    this.user.acceptChangeEmail(payLoad)
      .subscribe({
        next: (res: any) => {
          // this.emailToken = null;
          if (res.status) {
            localStorage.removeItem('emailtoken');
            this.emailSuccess = true;
            this.user.clearUserProfileCache();
            this.user.getUserProfile().subscribe({
              next: (profileRes: any) => {
                if (profileRes.status) {
                  this.auth.storeEmail(profileRes.data.email2);
                  this.userEmail = profileRes.data.email2;
                }
              }
            });
          } else {
            localStorage.removeItem('emailtoken');            
            alert(res.message);
          }
        },
        error: (err: any) => {
          console.log(err);
		  if (err.status == 401) {
			  this.auth.logout();
			  return
			}
        }
    })
  }

  close() {
    this.emailSuccess = false;
  }

  // trackBy function to prevent unnecessary re-rendering
  trackBySection(index: number, item: any): any {
    return item.section || index;
  }

  // 稼働を切り替える
  selectAssociate(index: number): void {
    if (this.allAssociatesData && index >= 0 && index < this.allAssociatesData.length) {
      this.selectedAssociateIndex = index;
      this.associatesData = [this.allAssociatesData[index]];
      this.chart?.update();
    }
  }
}
